
import React, { useState, useEffect } from 'react';
import { Badge } from '@/components/ui/badge';
import { Coins, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useWalletRepository } from '@/hooks/useRepositoryFactory';
import { useNavigate } from 'react-router-dom';

interface SeshBalanceProps {
  variant?: 'default' | 'secondary' | 'outline' | 'header';
  animated?: boolean;
  className?: string;
  hideText?: boolean;
}

export const SeshBalance: React.FC<SeshBalanceProps> = ({
  variant = 'default',
  animated = false,
  className = '',
  hideText = false
}) => {
  const [balance, setBalance] = useState<number | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const navigate = useNavigate();

  // Get repository via hook
  const walletRepository = useWalletRepository();

  const loadBalance = async () => {
    console.log('Carregando saldo...');
    const currentBalance = await walletRepository.getCurrentUserWalletBalance();
    console.log('Saldo carregado:', currentBalance);
    setBalance(currentBalance);
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    console.log('Forçando atualização do saldo...');
    try {
      const refreshedBalance = await walletRepository.refreshWalletBalance();
      console.log('Saldo atualizado:', refreshedBalance);
      setBalance(refreshedBalance);
    } catch (error) {
      console.error('Erro ao atualizar saldo:', error);
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    loadBalance();

    // Set up an interval to refresh balance every 30 seconds
    const interval = setInterval(loadBalance, 30000);

    return () => clearInterval(interval);
  }, []);

  // Map header variant to a valid badge variant
  const badgeVariant = variant === 'header' ? 'secondary' : variant;

  return (
    <div className="flex items-center gap-2">
      <Badge
        variant={badgeVariant}
        className={`flex items-center gap-1 ${animated ? 'transition-all duration-300 hover:scale-105' : ''} ${className} cursor-pointer`}
        onClick={() => navigate('/historico')}
      >
        <Coins className="h-3 w-3" />
        {!hideText && (
          <span>{balance !== null ? balance : '...'} Seshs</span>
        )}
      </Badge>

      <Button
        variant="ghost"
        size="sm"
        onClick={handleRefresh}
        disabled={isRefreshing}
        className="h-6 w-6 p-0"
        title="Atualizar saldo"
      >
        <RefreshCw className={`h-3 w-3 ${isRefreshing ? 'animate-spin' : ''}`} />
      </Button>
    </div>
  );
};
